var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tx__icon"},[_c('img',{class:_vm.transactionGroup,attrs:{"src":require("assets/images/logo.png"),"alt":"icon"}})])}
var staticRenderFns = []

export { render, staticRenderFns }